module.exports = __webpack_public_path__ + "img/iPhone.17fe4bcd.svg";